import { GraphQLReactQuery } from '@graphql/reactQuery';
import { SDK_KEY } from './helpers';

export function refetchSDK() {
  return GraphQLReactQuery.invalidateQueries({
    queryKey: [SDK_KEY],
  });
}
